module.exports = __webpack_public_path__ + "img/H-45-ER-550-B.c606851d.png";